import { render, staticRenderFns } from "./CreateSuplePage.vue?vue&type=template&id=3ac5c2ae"
import script from "./CreateSuplePage.js?vue&type=script&lang=js&external"
export * from "./CreateSuplePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports